import { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

const Settings = () => {
  const navigate = useNavigate();
  const [dark, setDark] = useState(false);
  const themeDispatch = useDispatch();
  const itemsForPageDispatch = useDispatch();

  const [itemsForPage, setItemsForPage] = useState(false);

  let HandlerTheme = () => {
    !dark ? setDark(true) : setDark(false);

    themeDispatch(!dark ? { type: "@theme/light" } : { type: "@theme/dark" });
  };

  const handlerOnClick = () => {
    itemsForPageDispatch({
      type: "@itemsForPage/change",
      payload: parseInt(itemsForPage),
    });
    navigate("/pokedex");
  };
  let arrNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 30];
  const list = arrNumbers.map((item, index) => (
    <option key={index} value={item}>
      {item}
    </option>
  ));
  return (
    <div className={`tA-left height80vh pad-mar width50vW`}>
      <FontAwesomeIcon icon={faArrowLeftLong} onClick={() => navigate(-1)} />

      <p className="  pad-mar">Settings</p>
      <div className="b-radius   pad-mar">
        <p className="">theme</p>
        <div className="cFilas tA-center  pad-mar-01">
          Dark
          {/* chekbox */}
          <div className={`swtich-container `}>
            <input type="checkbox" id="switch" onClick={HandlerTheme} />
            <label htmlFor="switch" className="lbl"></label>
          </div>
          {/* chekbox */}
          Light
        </div>
      </div>
      <div className=" pad-mar b-radius ">
        Items per page
        <br />
        <input
          className="boton"
          placeholder="write a number"
          onChange={(e) => setItemsForPage(e.target.value)}
        />
        <br />
        Or select one
        <select
          className="boton"
          onChange={(e) => setItemsForPage(e.target.value)}
        >
          {list}
        </select>
        <br />
        <button className="boton" onClick={handlerOnClick}>
          accepted changed
        </button>
      </div>
    </div>
  );
};

export default Settings;
